/* Elin Perfumes — promo tile video.
 *
 * The tile ships a still or looping GIF and only the video's source list.
 * The <video> element is built on the first press, so nothing downloads for
 * a tile the visitor never engages with — the point of using a light preview
 * loop rather than embedding the real file.
 */
(() => {
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-elin-video]');
    if (!button) return;

    event.preventDefault();

    let sources;
    try {
      sources = JSON.parse(button.dataset.elinVideo);
    } catch {
      return;
    }
    if (!Array.isArray(sources) || !sources.length) return;

    // The media box, not the banner: under the split layout the banner is the
    // full tile half, so mounting there let the video cover the text block.
    const stage = button.closest('.elin-promo__mediabox') || button.closest('.elin-promo__half');
    if (!stage || stage.querySelector('.elin-promo__video')) return;

    const video = document.createElement('video');
    video.className = 'elin-promo__video';
    video.controls = true;
    video.autoplay = true;
    video.playsInline = true;
    video.preload = 'auto';

    sources.forEach((source) => {
      if (!source?.src) return;
      const el = document.createElement('source');
      el.src = source.src;
      if (source.type) el.type = source.type;
      video.appendChild(el);
    });

    stage.appendChild(video);
    button.remove();
    video.play?.().catch(() => {
      // Autoplay with sound can be refused; the controls are already there.
    });
  });
})();
